import React from "react"
import { Container, Row, Col } from "reactstrap"

const Footer = () => {
  return (
    <React.Fragment>
      <footer className="footer">
        <Container fluid={true}>
          <Row className="d-flex justify-content-center align-items-center">
            <Col sm={6}>{new Date().getFullYear()} © Binary Ops Pvt Ltd..</Col>
            <Col sm={6} >
              <div style={{
                textAlign:'center'
              }}>
                Design & Develop by Binary Ops Team
              </div>
            </Col>
          </Row>
        </Container>
      </footer>
    </React.Fragment>
  )
}

export default Footer
